import { Either, Left, Right } from 'purify-ts'

export function parseJson<T>(json?: string): Either<void, T> {
  let parsed: Either<void, T> = Left(undefined)

  if (json !== undefined) {
    try {
      parsed = Right(JSON.parse(json))
    } catch {
      // already handled
    }
  }

  return parsed
}
